import { Helmet } from 'react-helmet-async';
import { seoPages, SITE_URL, SOCIAL_IMAGE, structuredData } from '@/config/seo';

export function SEO({ canonical }: { canonical: string }) {
  const page = seoPages[canonical] || seoPages['/404'];
  const url = `${SITE_URL}${canonical}`;
  const image = `${SITE_URL}${SOCIAL_IMAGE}`;
  const isNotFound = page === seoPages['/404'];

  return (
    <Helmet>
      <title>{page.title}</title>
      <meta name="description" content={page.description} />
      <meta name="robots" content={page.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'} />
      {!isNotFound && <link rel="canonical" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Somatiq" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      {!isNotFound && <meta property="og:url" content={url} />}
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="Somatiq — radiology software and reporting" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content="Somatiq — radiology software and reporting" />
      {!isNotFound && <script type="application/ld+json">{JSON.stringify(structuredData(canonical, page)).replace(/</g, '\\u003c')}</script>}
    </Helmet>
  );
}
